import { useTranslation } from 'react-i18next';
import { cn } from '@Utils';

import { FieldServiceContract } from '@Models';
import { isKnownTaskType, UPPERCASE_LABEL_CLASS_NAME } from '../constants';

interface TaskTypesSectionProps {
  contract: FieldServiceContract;
}

const TaskTypesSection = ({ contract }: TaskTypesSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-6">
      <div>
        <span className={cn('block', UPPERCASE_LABEL_CLASS_NAME)}>{t('FieldService.Sections.TaskTypes')}</span>
        <p className="mb-0 mt-2 text-xs text-gray-500">{t('FieldService.Contract.ApprovedTaskTypesDesc')}</p>
      </div>

      {contract.approved_task_types.length > 0 ? (
        <div className="flex flex-wrap gap-[7px]">
          {contract.approved_task_types.map((taskType) => (
            <span
              key={taskType}
              className="inline-flex items-center gap-2 rounded-[9px] border border-gray-300 bg-gray-50 px-3 py-2 text-xs font-semibold text-gray-900">
              {isKnownTaskType(taskType) ? t(`FieldService.TaskTypeName.${taskType}`) : taskType}
            </span>
          ))}
        </div>
      ) : (
        <span className="text-sm italic text-gray-500">{t('FieldService.NotConfigured')}</span>
      )}
    </div>
  );
};

export default TaskTypesSection;
